import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import './footer.css';

function Footer() {
  return (
    <footer className="ef-footer" role="contentinfo">
      <div className="ef-topline" aria-hidden="true" />

      <div className="ef-wrap">
        {/* ===== Column 1: About ===== */}
        <section className="ef-col" aria-labelledby="about-heading">
          <h3 id="about-heading" className="ef-heading">About</h3>

          <div className="ef-brand">
            <div className="ef-logo" aria-hidden="true">E</div>
            <div className="ef-brand-text">
              <p className="ef-title">Ecodesign &amp; Protect Ltd</p>
              <p className="ef-tag">Designing sustainable, nature-first outcomes.</p>
            </div>
          </div>

          <p className="ef-copy">
            Ecodesign &amp; Protect Ltd is a leading environmental consultancy dedicated to
            sustainable development and innovative environmental solutions.
          </p>

          <div className="ef-social" aria-label="Social links">
            <a href="https://facebook.com" className="ef-social-btn" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <Facebook size={18} />
            </a>
            <a href="https://twitter.com" className="ef-social-btn" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
              <Twitter size={18} />
            </a>
            <a href="https://linkedin.com" className="ef-social-btn" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
              <Linkedin size={18} />
            </a>
            <a href="mailto:info@ecodesignprotect.rw" className="ef-social-btn" aria-label="Email">
              <Mail size={18} />
            </a>
          </div>
        </section>

        {/* ===== Column 2: Quick Links ===== */}
        <nav className="ef-col" aria-label="Quick links">
          <h3 className="ef-heading">Quick Links</h3>
          <ul className="ef-links">
            <li><Link to="/" className="ef-link">Home</Link></li>
            <li><Link to="/about-us" className="ef-link">About Us</Link></li>
            <li><Link to="/our-services" className="ef-link">Services</Link></li>
            <li><Link to="/our-partners" className="ef-link">Clients &amp; Partners</Link></li>
            <li><Link to="/contact-us" className="ef-link">Contact</Link></li>
          </ul>
        </nav>

        {/* ===== Column 3: Contact ===== */}
        <section className="ef-col" aria-labelledby="contact-heading">
          <h3 id="contact-heading" className="ef-heading">Contact</h3>
          <ul className="ef-contact">
            <li className="ef-contact-item">
              <MapPin size={18} aria-hidden="true" />
              <span>Kimihurura, Ubumwe House, 2nd Floor, KG 5 Avenue</span>
            </li>
            <li className="ef-contact-item">
              <Phone size={18} aria-hidden="true" />
              <a href="tel:+250788306105" className="ef-link">+250 788 306 105</a>
            </li>
            <li className="ef-contact-item">
              <Mail size={18} aria-hidden="true" />
              <a href="mailto:info@ecodesignprotect.rw" className="ef-link">info@ecodesignprotect.rw</a>
            </li>
          </ul>
        </section>
      </div>

      {/* Bottom line only, centered */}
      <div className="ef-bottom ef-bottom--center">
        <p>© 2025 Ecodesign &amp; Protect Ltd. All rights reserved.</p>
      </div>

      {/* Decorative blobs */}
      <div className="ef-blob ef-blob-a" aria-hidden="true" />
      <div className="ef-blob ef-blob-b" aria-hidden="true" />
    </footer>
  );
}

export default Footer;
